import { render } from "./ApplicationSMSInform.html?vue&type=template&id=68db2510&scoped=true"
import script from "./ApplicationSMSInform.js?vue&type=script&lang=js"
export * from "./ApplicationSMSInform.js?vue&type=script&lang=js"

import "./ApplicationSMSInform.scss?vue&type=style&index=0&id=68db2510&lang=scss&scoped=true"
import "./ApplicationSMSInform.vue?vue&type=style&index=1&id=68db2510&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68db2510"]])

export default __exports__